export default "__VITE_ASSET__7b8eb90b__"